module.exports = __webpack_public_path__ + "static/media/Concern_Worldwide_logo.7ee3ffbe.png";